import { validations } from "./Validations";
import { Tooltip, Forms } from "@types/FormTypes";
import { __ } from "@wordpress/i18n";

/**
 * Labels used for the fields in the example form.
 * These labels are in Portuguese (Portugal) for user interface consistency.
 */
const LABELS = {
    title: __("Dados para a simulação", "df-simulators"),
    headingCurrentCredit: __("Crédito atual", "df-simulators"),
    headingNewCredit: __("Novo crédito", "df-simulators"),
    currentCapital: __("Capital em dívida", "df-simulators"),
    interestRate: __("Taxa de juro (spread+euribor)", "df-simulators"),
    installments: __("Prestações a pagar (em meses)", "df-simulators"),
};

/**
 * Tooltips used in the example form fields.
 * These tooltips provide additional context to users, localized to Portuguese (Portugal).
 */
const TOOLTIPS: Record<string, Tooltip> = {
    interestRate: {
        title: __("Taxa de juro", "df-simulators"),
        content: __(
            "Taxa Anual Nominal (TAN). Num crédito a taxa variável, a TAN é composta pela soma do spread com a taxa Euribor.",
            "df-simulators"
        ),
        placement: "right",
    },
};

/**
 * Configuration constants for the API used in the example form.
 */
const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/loan/savings`;
const PROCESS_TYPE = 4;
const OPERATION_TYPE = 2;


/**
 * Simulator custom URL - Check if exists some custom URL for this block
 * [==START==]
 */
let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector('[data-block="tool-block"]') as HTMLElement | null;
if ( rootElement !== null ) {
  const NEW_URL = rootElement.getAttribute('data-tool-managment');
  if ( NEW_URL !== null && NEW_URL !== '' ) {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}
/* [==END==] */


/**
 * Example form configuration for the base block.
 * This configuration demonstrates various field types available for block development.
 */
export const forms: Forms = {
    loan_savings: {
        validation: validations.loan_savings,
        api: {
            url: MIDDLEWARE_API_URL,
            processType: PROCESS_TYPE,
            operationType: OPERATION_TYPE,
        },
        fields: [
            {
                type: "title",
                label: LABELS.title,
            },
            {
                type: "heading",
                label: LABELS.headingCurrentCredit,
            },
            {
                type: "number",
                label: LABELS.currentCapital,
                name: "current_loanValue",
                icon: "currency",
                defaultValue: 100000,
            },
            {
                type: "number",
                label: LABELS.interestRate,
                name: "current_rate",
                icon: "percentage",
                tooltip: TOOLTIPS.interestRate,
                defaultValue: 1.00,
            },
            {
                type: "number",
                label: LABELS.installments,
                name: "current_numberOfTotalInstallments",
                defaultValue: 360,
            },
            {
                type: "heading",
                label: LABELS.headingNewCredit,
            },
            {
                type: "number",
                label: LABELS.currentCapital,
                name: "new_loanValue",
                icon: "currency",
                defaultValue: 100000,
            },
            {
                type: "number",
                label: LABELS.interestRate,
                name: "new_rate",
                icon: "percentage",
                defaultValue: 1.0,
            },
            {
                type: "number",
                label: LABELS.installments,
                name: "new_numberOfTotalInstallments",
                defaultValue: 360,
            },
        ],
    },
};
